import { Component, Input } from '@angular/core';
import { Patient } from '../../../models/patient';
import { TraitementDataComponent } from '../traitement-data/traitement-data.component';
import { ALaDateDuPipe } from '../../../pipes/a-la-date-du.pipe';
import { ArretTabacStatutPipe } from '../../../pipes/arret-tabac-statut.pipe';

@Component({
  selector: 'app-traitement-data-arret-tabac',
  standalone: true,
  imports: [TraitementDataComponent, ALaDateDuPipe, ArretTabacStatutPipe],
  templateUrl: './traitement-data-arret-tabac.component.html',
  styleUrl: './traitement-data-arret-tabac.component.scss',
})
export class TraitementDataArretTabacComponent {
  @Input() patient: Patient | undefined;
}
